import type { Bundle } from "@memorang/types";

export const mockedProductDetails = {
	data: {
		productDetails: {
			id: 3,
			name: "Rocket Test Prep",
			numericId: 178,
			isPracticeTest: false,
			isPublished: true,
			isMobileOnly: false,
			examName: "Rocket Test Prep",
			examId: 1,
			examUUID: "e783a8c3-951c-48c3-9b8a-fd464a27d1d3",
			bundleType: "DIRECT",
			bundleSubType: "STUDY_PACK",
			productType: "DIRECT",
			productSubType: "STUDY_PACK",
			description: "Rocket Test Prep",
			features: [
				"410 items similar to what you'll see on test day",
				"Authored by the official Rocket Test Prep team",
				"Track progress across reading, writing, listening, and speaking",
				"AI-powered grading, hints, tutoring, and personalized feedback",
			],
			features_mandarin: [
				"410 个与您考试当天所见相似的题目",
				"由官方 TOEFL 团队编写",
				"跟踪阅读、写作、听力和口语各方面的进度",
				"AI 驱动的评分、提示、辅导和个性化反馈",
			],
			featuresMandarin: [
				"410 个与您考试当天所见相似的题目",
				"由官方 TOEFL 团队编写",
				"跟踪阅读、写作、听力和口语各方面的进度",
				"AI 驱动的评分、提示、辅导和个性化反馈",
			],
			featuresJapanese: [
				"410問の試験当日に出題されるものと類似した問題",
				"TOEFL公式チームによる作成",
				"リーディング、ライティング、リスニング、スピーキングの進捗状況を追跡",
				"AIによる採点、ヒント、指導、個別フィードバック",
			],
			icon: {
				url: "https://icon.memorang.com/icon/acme.png",
			},
			categories: ["Test Prep"],
			categoryIds: [2],
			bundles: [],
			plans: [
				{
					id: 4975,
					productId: 3,
					name: "Rocket Test Prep - 3 Months",
					description: "Rocket Test Prep - 3 Months",
					amount: 79.99,
					currency: "usd",
					interval: "month",
					duration: 3,
					type: "FULL_ACCESS",
					createdAt: "2025-04-02 11:58:32.195442",
					updatedAt: "2025-04-02 11:58:32.195442",
					priceId: "price_0R9RwmJohR7dUmjaJfPBdlcI",
					backup: {
						planType: "FULL_ACCESS",
					},
					tenantId: "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
					tierId: null,
					isDeleted: false,
					metadata: null,
					logicalId: "b426ef2d-0255-4514-87ac-b12036418655",
					originalAmount: 99.99,
					internalId: "4",
					numericId: 4228,
					projectId: null,
					sku: null,
					isListed: true,
				},
				{
					id: 4976,
					productId: 3,
					name: "Rocket Test Prep - 6 Months",
					description: "Rocket Test Prep - 6 Months",
					amount: 99.99,
					currency: "usd",
					interval: "month",
					duration: 6,
					type: "FULL_ACCESS",
					createdAt: "2025-04-02 12:00:04.414493",
					updatedAt: "2025-04-02 12:00:04.414493",
					priceId: "price_0QUv3xJohR7dUmjagyYfceZP",
					backup: {
						planType: "FULL_ACCESS",
					},
					tenantId: "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
					tierId: null,
					isDeleted: false,
					metadata: null,
					logicalId: "fb2035cc-2ae1-4a8f-9a43-bc8b19654ddc",
					originalAmount: 129.99,
					internalId: "5",
					numericId: 4229,
					projectId: null,
					sku: null,
					isListed: true,
				},
				{
					id: 295,
					productId: 3,
					name: "Official Rocket Test Prep AI Coach Study-Pack",
					description: "Cramming",
					amount: 39.99,
					currency: "usd",
					interval: "day",
					duration: 7,
					type: "FULL_ACCESS",
					createdAt: "2024-11-29 13:09:03.890141",
					updatedAt: "2025-08-19 11:46:07.341",
					priceId: "price_0QUv3xJohR7dUmjakU66qcQE",
					backup: {
						t: "Official Rocket Test Prep AI Coach Study-Pack",
						id: "69e253e8-8648-4112-9224-6fd03e5ba1c3",
						sd: "Test questions that mirror what you'll see on exam day",
						sk: "PLN!V",
						amt: 39.99,
						bId: "6da87b56-3d30-450a-b097-20fc5a360b39",
						cur: "usd",
						dtC: "2024-11-29T13:09:03.851Z",
						dtU: "2024-11-29T13:09:03.851Z",
						dur: 7,
						exn: "Rocket Test Prep Study-Pack",
						iId: "69e253e8-8648-4112-9224-6fd03e5ba1c3",
						isD: false,
						isL: true,
						itv: "day",
						oId: null,
						prc: "price_0QUv3xJohR7dUmjakU66qcQE",
						ref: "com.memorang.178.day.7",
						typ: "PLAN",
						uId: "5922c06d-56e1-4b3f-9229-e48e453f6ef2",
						xId: "69e253e8-8648-4112-9224-6fd03e5ba1c3",
						alias: "1 Week - Cramming",
						tierId: null,
						planType: "FULL_ACCESS",
						tenantId: "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
					},
					tenantId: "5c5a1f03-3dd8-4db4-9a72-77a1686971d9",
					tierId: null,
					isDeleted: false,
					metadata: null,
					logicalId: "69e253e8-8648-4112-9224-6fd03e5ba1c3",
					originalAmount: 49.99,
					internalId: "1",
					numericId: 2201,
					projectId: null,
					sku: null,
					isListed: true,
				},
			],
			tiers: [],
			freeTierFeatures: [],
			logicalId: "6da87b56-3d30-450a-b097-20fc5a360b39",
		},
	},
} as unknown as {
	data: {
		productDetails: Bundle;
	};
};
